module.exports = __webpack_public_path__ + "static/media/brasao.cbd48ca5.png";